import React, { useState } from 'react';
import api from '../../../api';
import { Input } from '../form/Form';
import Button from '../button/Button';
import { notification } from 'antd';
import { FormOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

const EditableInput = ({
  inputType,
  inputName,
  placeholder,
  label,
  value,
  regex,
  validationMessage,
  shouldDisable,
}) => {
  const [showSaveBtns, setShowSaveBtns] = useState(false);
  const [validationFailed, setValidationFailed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    fieldName: inputName,
    fieldValue: value,
  });

  const onChangeHandler = (e) => {
    const value = e.target.value;
    console.log({ value });
    setInput({ fieldName: e.target.name, fieldValue: value });
    if (regex && !RegExp(regex).test(value)) {
      setValidationFailed(true);
    } else {
      setValidationFailed(false);
    }
  };

  const onSaveHandler = (e) => {
    setLoading(true);
    e.preventDefault();
    // delay feedback by at least half a second
    setTimeout(async () => {
      if (input.fieldName !== 'password') {
        await api.updateUserField(input);
      }
      if (input.fieldName === 'password') {
        const values = { password: input.fieldValue };
        const res = await api.changeUserPassword(values.password);

        if (res.error) {
          notification.error({ message: res.error });
          setLoading(false);
          return;
        }
      }
      notification.success({
        message: `${label} successfully updated`,
      });
      setLoading(false);
      setShowSaveBtns(false);
    }, 500);
  };

  const editClickHandler = () => {
    setShowSaveBtns(true);
  };

  const cancelSaveHandler = () => {
    setShowSaveBtns(false);
    setValidationFailed(false);
    setInput({
      fieldName: inputName,
      fieldValue: value,
    });
  };
  console.log({ input, value });
  return (
    <div className="editable-input flex flex-col mb-4">
      <label htmlFor={inputName} className="text-lg text-bold">
        {label}
      </label>
      <div className="flex mt-4 flex-col md:flex-row">
        <Input
          type={inputType}
          name={inputName}
          id={inputName}
          value={input.fieldValue}
          onChange={onChangeHandler}
          disabled={!showSaveBtns || loading || shouldDisable}
          placeholder={placeholder}
        />
        {showSaveBtns ? (
          <div className="flex">
            <Button
              icon={<CheckOutlined />}
              loading={loading}
              className="flex w-full justify-center items-center border py-2 px-4 border-blue cursor-pointer h-10"
              onClick={onSaveHandler}
              disabled={validationFailed}
            >
              Save
            </Button>
            <Button
              disabled={loading}
              secondary
              icon={<CloseOutlined />}
              className="flex w-full justify-center items-center border py-2 px-4 border-blue cursor-pointer h-10"
              onClick={cancelSaveHandler}
            >
              Cancel
            </Button>
          </div>
        ) : (
          !shouldDisable && (
            <Button
              icon={<FormOutlined />}
              className="flex justify-center items-center border py-2 px-4 border-blue cursor-pointer h-10"
              onClick={editClickHandler}
            >
              Edit
            </Button>
          )
        )}
      </div>
      {validationFailed && (
        <div className="mt-2 text-orange-500">
          {validationMessage || 'Input is invalid'}
        </div>
      )}
    </div>
  );
};

export default EditableInput;
